// /src/components/ModalContainer.js
// Container que renderiza los modales de Signup y Login basado en ModalContext
// Gestiona la visualización de ambos modales y el manejo de escape key

import React, { useEffect } from 'react';
import { useModal } from '../context/ModalContext';
import SignupV3 from './SignupV3';
import LoginV3 from './LoginV3';

const ModalContainer = () => {
  const { isSignupOpen, isLoginOpen, closeModal } = useModal();

  // Handle Escape key to close modal
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === 'Escape' && (isSignupOpen || isLoginOpen)) {
        closeModal();
      }
    };

    if (isSignupOpen || isLoginOpen) {
      document.addEventListener('keydown', handleEscapeKey);
      return () => document.removeEventListener('keydown', handleEscapeKey);
    }
  }, [isSignupOpen, isLoginOpen, closeModal]);

  return (
    <>
      {isSignupOpen && <SignupV3 onClose={closeModal} />}
      {isLoginOpen && <LoginV3 onClose={closeModal} />}
    </>
  );
};

export default ModalContainer;
